import { createContext } from 'react';
const AVContext = createContext({}); // Asserting since this will always be set
const AVStateContext = createContext({
    roomState: 'Unset',
    peers: [],
});
export { AVContext, AVStateContext };
//# sourceMappingURL=context.js.map